import { eReducerStatusBase } from "../../page-state-model/eReducerStatusBase";
import { v4 as uuidv4 } from 'uuid';
import { IThuPhiReducer, IThuPhiTabReducer } from "../../page-state-model/IThuPhiTabReducer";
import { IThuPhiTabActionTypes } from "../../action-types/thu-phi-tabs/IThuPhiTabActionType";
const iniTab: IThuPhiTabReducer = {
    id: uuidv4(),
    title: "Untitled",
    step: 0,
    status: eReducerStatusBase.is_not_initialization,
    request: {
        ts_hocsinh_id: 0,
        nam_hoc: ''
    },
    categorySelectedId: 0,

}
const iniState: IThuPhiReducer = {
    selectedId: iniTab.id,
    tabs: [iniTab]
}
export const thuPhiTabReducer = (state: IThuPhiReducer = iniState, action: IThuPhiTabActionTypes): IThuPhiReducer => {
    switch (action.type) {
        case "THU_PHI_TAB_ADD_NEW_TAB":
            const id = uuidv4();
            return {
                ...state,
                selectedId: id,
                tabs: [{ ...iniTab, id: id }, ...state.tabs]
            }
        case "THU_PHI_TAB_REMOVE_TAB":
            return {
                ...state,
                tabs: state.tabs.filter(t => t.id !== action.payload),
                selectedId: state.tabs.length >= 1 ? state.tabs[0].id : ""
            }
        case "THU_PHI_TAB_UPDATE_TAB_DATA":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.id) {
                        return action.payload
                    }
                    return t;
                })
            }
        case "THU_PHI_TAB_CHANGEG_SELECTED_TAB":
            return {
                ...state,
                selectedId: action.payload
            }
        case "THU_PHI_TAB_CREATE_THUPHI_START":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_saving
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_CREATE_THUPHI_SUCCCESS":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            donHangId: action.payload.data,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_CREATE_THUPHI_ERROR":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_LOAD_THU_PHI_START":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_loading
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_LOAD_THU_PHI_SUCCESS":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            donHangs: action.payload.data,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_LOAD_THU_PHI_ERROR":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        default:
            return state;
    }
}